module.exports = __webpack_public_path__ + "static/img/subscription_upgraded.5eba2ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/subscription_upgraded.png
// module id = CzMZ
// module chunks = 134